import { RoleEnum } from "../../utils/api";
import VerificationBadge from "./VerificationBadge";

interface OwnProps {
    userRole?: RoleEnum;
}

export type Props = OwnProps;

export default VerificationBadge;